export class FeedProperties {
	Id?: number;
	FeedId: number;
	IsEditable: boolean;
	DisplayOrdinal: number;
	Key: string;
	Value: any;
}